import { useRef } from 'react';
import useEffectWithCtx from './useEffectWithCtx';
export default function useEffectUntilDone(cb, deps) {
    const completed = useRef(false);
    useEffectWithCtx(ctx => {
        if (!completed.current) {
            ctx.cb(() => {
                completed.current = true;
            });
        }
    }, { cb }, deps);
}
